import styled from "styled-components";

export const Wrapper = styled.div`
.receiver{
    min-width: 200px;
}
.profileIcon {
    width: 16px;
    height: 16px;
    stroke: blue;
    fill: blue;
    margin-left: 5px;
}
.message-box {
    min-width: 250px;
    width: 40%;
}
`;
